import { Component, OnInit } from '@angular/core';
import { BasePage } from '../../../shared/components/base-page.component';

@Component({
    selector: 'terms-page',
    standalone: true,
    imports: [...BasePage.BaseImports],
    templateUrl: './TermsPage.html',
    styleUrl: './TermsPage.css',
})

export class TermsPage implements BasePage, OnInit
{
    constructor()
    {
    }

    async ngOnInit()
    {
    }
}
